import { ApiError } from '@/shared/api/apiFetch';

export function authErrorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.status === 401) {
      return 'Неверный логин или пароль. Проверьте данные и попробуйте снова.';
    }
    if (err.status === 403) {
      return 'Доступ запрещён. Обратитесь к администратору.';
    }
    if (err.status === 404) {
      return 'Сервис авторизации временно недоступен. Попробуйте позже.';
    }
    if (err.status === 422 || err.status === 400) {
      return err.message || 'Проверьте корректность введённых данных.';
    }
    if (err.message.trim()) return err.message;
  }
  if (err instanceof Error && err.message === 'SESSION_INACTIVE') {
    return 'Учётная запись неактивна или сессия завершена. Обратитесь к администратору.';
  }
  return 'Не удалось выполнить вход. Попробуйте ещё раз.';
}
